

@if (contact().title?.[translate.getCurrentLang()]; as title) {
  <h3 class="title-contact">{{title}}</h3>
}
@if (contact().fieldgen?.length > 0) {
    <div class="detail-item">
      <mat-icon fontSet="material-icons-round">map</mat-icon>
      <div class="detail-item-label">{{contact().fieldgen}}</div>
    </div>
  }
  @if (contact().creationplace?.length > 0) {
    <div class="detail-item">
      <mat-icon fontSet="material-icons-round">email</mat-icon>
      <a [href]="'mailto:' + contact().creationplace">{{contact().creationplace}}</a>
    </div>
  }
  @if (contact().creatorbirth?.length > 0) {
    <div class="detail-item">
      <mat-icon fontSet="material-icons-round">web</mat-icon>
      <a [href]="contact().creatorbirth">{{contact().creatorbirth}}</a>
    </div>
  }
  @if (contact().creatordeath?.length > 0) {
    <div class="detail-item">
      <mat-icon fontSet="material-icons-round">call</mat-icon>
      <a [href]="'tel:' + contact().creatordeath">{{contact().creatordeath}}</a>
    </div>
  }